module.exports = __webpack_public_path__ + "img/icn-arrow-down.2b597af5.svg";